export const GTM_ENUM = {
  proceedBtnEmailPopupAPIex: "proceed-btn-email-popup_APIex",
  gobackBtnEmailPopupAPIex: "goback-btn-email-popup_APIex",
  resendOtpPopupAPIex: "resend-otp-popup_APIex",
  proceedBtnOtpPopupAPIex: "proceed-btn-otp-popup_APIex",
  gobackBtnOtpPopupAPIex: "goback--btn-otp-popup_APIex",
  getintouchBtnHeaderAPIex: "getintouch-btn-header_APIex",
  getintouchBtnCreditsAPIex: "getintouch-btn-credits_APIex",
  submitRequestBtnAPIex: "submit-request-btn_APIex",
};
